import SuiteIcon from './SuiteIcon';

export default SuiteIcon;
